// src/pages/Home.js
import React from 'react';
import WebpageShell from './WebpageShell';
import HelmetTemplate from '../utils/HelmetTemplate';
import Hero from '../components/HomepageComponents/Hero.js';
import ReviewCardsSection from '../components/HomepageComponents/ReviewCardsSection.js';
import HookSection from '../components/HomepageComponents/HookSection.js';
import HowItWorks from '../components/HomepageComponents/HowItWorks.js';
import LearnMore from '../components/HomepageComponents/LearnMore.js';
import FAQ from '../components/HomepageComponents/FAQ.js';

export default function Home() {
  // Data Source: User Provided Values + Schema.org Best Practices
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://matchmedic.com/#organization",
    "name": "Match Medic",
    "alternateName": "Match Medic",
    "legalName": "Match Medic Sağlık Yazılım ve Bilişim Anonim Şirketi",
    "description": "Match Medic Sağlık Yazılım ve Bilişim Anonim Şirketi, or Match Medic, is a company established in 2025 that helps people find suitable cosmetic surgery healthcare providers abroad. It serves as an intermediary by onboarding and guiding people toward licensed and legitimate clinics. Match Medic owns and operates matchmedic.com, which is the primary product and free onboarding tool that people can use to find the best healthcare providers possible.",
    "url": "https://matchmedic.com/",
    "logo": "https://matchmedic.com/favicon.png", 
    "foundingDate": "2024-12-05",
    "numberOfEmployees": {
      "@type": "QuantitativeValue",
      "value": "2-10"
    },
    "email": "alpmungan@matchmedic.com",
    "telephone": "+908503469160",
    "taxID": "6132075576",
    "vatID": "6132075576",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Maslak Mahallesi AOS 55. Sokak 42 Maslak B Blok Sitesi No: 4 İç Kapı: 542 Sarıyer / İstanbul",
      "addressLocality": "Sarıyer", 
      "addressRegion": "İstanbul",
      "postalCode": "34485",
      "addressCountry": "TR"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+908503469160",
      "contactType": "customer service",
      "email": "alpmungan@matchmedic.com",
      "availableLanguage": "English"
    },
    "sameAs": [
      "https://www.linkedin.com/company/matchmedic/",
      "https://www.tiktok.com/@matchmedic",
      "https://www.facebook.com/people/Match-Medic/61572281754989/",
      "https://www.instagram.com/matchmedic/",
      "https://x.com/usematchmedic/",
      "https://www.youtube.com/@MatchMedic"
    ]
  };

  return (
    <WebpageShell
      navProps={{ addAnnouncementBar: false, isRecPrototypePage: false }}
      showCTA={true}
    >
      <HelmetTemplate
        title="Match Medic"
        description="Welcome to Match Medic – Find the right hair transplant clinic for your unique needs. Cut through the noise and misinformation surrounding hair transplants."
        canonicalUrl="https://matchmedic.com/"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
        
      <Hero
        title="Hair restoration without fear"
        buttonLabel="Get your confidence back →"
        onButtonClick={() => window.location.assign('/onboarding')}
      />

      <ReviewCardsSection theme="dark" />
      <HookSection />
      <HowItWorks />
      <LearnMore className=""/>
      <FAQ />

    </WebpageShell>
  );
}